import React from 'react'
import { useTranslation } from 'react-i18next'

import { Calendar } from 'primereact/calendar'
import { InputText } from 'primereact/inputtext'
import { InputTextarea } from 'primereact/inputtextarea'

import { PanelContainer } from '../../../../components/Panel'
import { getConfigTranslation } from '../../../../utils/helper/getConfigTranslation'
import { ConfigurableComponent } from '../../../../utils/wrapper'
import { useConfigContext } from '../../../ui-config'
import { useDeliveryForecastDespatchAdviceById } from '../../data'

type Props = {
  despatchAdviceId: string
}

export const ForecastDeliveryScheduleInformation: React.FC<Props> = ({
  despatchAdviceId,
}) => {
  const { i18n } = useTranslation()
  const { language } = i18n

  const { data, isLoading } =
    useDeliveryForecastDespatchAdviceById(despatchAdviceId)
  const { uiConfig: config } = useConfigContext()

  // ************************************************************
  // components
  // ************************************************************
  // orderId
  const orderIdLabel = <label className="text-sm" htmlFor="orderId"></label>

  const orderIdComponent = (
    <InputText
      id="orderId"
      value={data?.Payload.OrderId}
      className="w-full"
      disabled
    />
  )

  const orderIdWrapper = (
    <ConfigurableComponent
      config={
        config.deliveryForecastDespatchAdvice
          .forecastDeliveryScheduleInformation
      }
      component={orderIdComponent}
      label={orderIdLabel}
      className="col-12 md:col-6 lg:col-4 xl:col-3"
      isLoading={isLoading}
    />
  )

  // orderDate
  const orderDateLabel = <label className="text-sm" htmlFor="orderDate"></label>

  const orderDateComponent = (
    <Calendar
      id="orderDate"
      value={new Date(data?.Payload.OrderDate!)}
      className="w-full"
      locale={language}
      disabled
    />
  )

  const orderDateWrapper = (
    <ConfigurableComponent
      config={
        config.deliveryForecastDespatchAdvice
          .forecastDeliveryScheduleInformation
      }
      component={orderDateComponent}
      label={orderDateLabel}
      className="col-12 md:col-6 lg:col-4 xl:col-3"
      isLoading={isLoading}
    />
  )

  // currentReleaseNumber
  const currentReleaseNumberLabel = (
    <label className="text-sm" htmlFor="currentReleaseNumber"></label>
  )

  const currentReleaseNumberComponent = (
    <InputText
      id="currentReleaseNumber"
      value={data?.Payload.CurrentReleaseNumber}
      className="w-full"
      disabled
    />
  )

  const currentReleaseNumberWrapper = (
    <ConfigurableComponent
      config={
        config.deliveryForecastDespatchAdvice
          .forecastDeliveryScheduleInformation
      }
      component={currentReleaseNumberComponent}
      label={currentReleaseNumberLabel}
      className="col-12 md:col-6 lg:col-4 xl:col-3"
      isLoading={isLoading}
    />
  )

  // orderNotes
  const orderNotesLabel = (
    <label className="text-sm" htmlFor="orderNotes"></label>
  )

  const orderNotesComponent = (
    <InputTextarea
      id="orderNotes"
      value={data?.Payload.OrderNotes}
      rows={5}
      className="w-full"
      disabled
    />
  )

  const orderNotesWrapper = (
    <ConfigurableComponent
      config={
        config.deliveryForecastDespatchAdvice
          .forecastDeliveryScheduleInformation
      }
      component={orderNotesComponent}
      label={orderNotesLabel}
      className="col-12"
      isLoading={isLoading}
    />
  )

  return (
    <PanelContainer
      header={getConfigTranslation(
        config.deliveryForecastDespatchAdvice
          .forecastDeliveryScheduleInformation.title,
      )}
      id="delivery-forecast-despatch-advice-delivery-forecast-details"
      visible={
        config.deliveryForecastDespatchAdvice
          .forecastDeliveryScheduleInformation.enabled !== false
      }
    >
      <div className="formgrid grid">
        {/* orderId */}
        {orderIdWrapper}

        {/* orderDate */}
        {orderDateWrapper}

        {/* currentReleaseNumber */}
        {currentReleaseNumberWrapper}

        {/* orderNotes */}
        {orderNotesWrapper}
      </div>
    </PanelContainer>
  )
}
